import {createActionGroup, emptyProps, props} from '@ngrx/store';

export const CommonsActions = createActionGroup({
  source: '[Commons]',
  events: {
    setLoaderOn: emptyProps(),
    setLoaderOff: emptyProps()
  },
});
